import {
  SUPPORTED_LOCALE_LIST,
  ID_ID,
  JA_JP,
  KO_KR,
  MS_MY,
  TH_TH,
  VI_VN,
} from '@snapask/common-components/dist/constants/locales';

const localeFolderMapping = {
  ...SUPPORTED_LOCALE_LIST,
  [ID_ID]: 'id',
  [JA_JP]: 'ja',
  [KO_KR]: 'ko',
  [MS_MY]: 'ms',
  [TH_TH]: 'th',
  [VI_VN]: 'vi',
};

export default localeFolderMapping;



// WEBPACK FOOTER //
// ./app/constants/localeFolderMapping.js